module.exports = __webpack_public_path__ + "img/ai_feedback.439e9b5.png";